import clsx from 'clsx';

interface BadgeProps {
    style?: 'basic' | 'square' | 'circle';
    light?: boolean;
    color?: string;
    text: string;
    size?: 'small' | 'medium' | 'large';
}
const Badge = ({
    style = 'basic',
    light,
    color = 'primary',
    text,
    size = 'medium',
}: BadgeProps): JSX.Element => {
    const lightPrefix = light ? 'light-' : '';
    const colorClass = `badge-${lightPrefix}${color}`;

    return (
        <span
            className={clsx('badge', colorClass, {
                'badge-square': style === 'square',
                'badge-circle': style === 'circle',
                'badge-sm': size === 'small',
                'badge-lg': size === 'large',
            })}
        >
            {text}
        </span>
    );
};
export default Badge;
